import React from "react";
import { CpCheckbox } from "@components";
import type { Selection } from "../hooks/use-table-selection.hook";

type SelectAllHeaderProps = {
  selection: Selection;
};

export function SelectAllHeader({ selection }: SelectAllHeaderProps) {
  return (
    <CpCheckbox
      checked={
        selection.length > 0 && !selection.allSelected
          ? "indeterminate"
          : selection.allSelected
      }
      onChange={(checked) =>
        checked ? selection.selectAll() : selection.deselectAll()
      }
    />
  );
}
